module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.noActiveSchoolYears) ? _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.common.no_active_school_years')))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb56e46e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Banner.vue
// module id = 2105
// module chunks = 1